export default __webpack_public_path__ + "static/media/chevron-right.de20dd0a.svg";